import styled from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';

const Header = styled.div`
  padding-bottom: 1.5rem;
  margin-bottom: 1.5rem;

  border-bottom: 0.1rem solid ${pickColor('borderLight')};
`;

const Status = styled.div`
  display: flex;

  width: 57rem;

  &:not(:last-of-type) {
    margin-bottom: 0.3rem;
  }
`;

const Label = styled.p`
  margin-left: 0.5rem;

  color: ${pickColor('greenStatus')};
`;

export { Header, Status, Label };
